<template>
    <div>
        <el-form>
            <el-form-item :label="label" style="width: 100%;">
                <el-input :placeholder="placeholder" v-model="formInline" :suffix-icon="showTree?'el-icon-arrow-up':'el-icon-arrow-down'" @click.native="deptogglePanel($event)" size="mini" readonly="readonly">
                </el-input>
                <div v-if="showTree" class="treeDiv" ref="tableList">
                    <el-input style="padding: 0 10px" size="mini" v-model="ss" @change="searchInputChange" :placeholder="seachholder" />
                    <el-table @row-click="handleRegionNodeClick" ref="moviesTable" :data="memberList" border stripe :cell-style="getCellStyle" :header-cell-style="getHeaderCellStyle">
                        <el-table-column v-for="(item, index) in Columns" :key="index" :prop="item.prop" :label="item.label" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div v-if="item.prop == 'createTime'">
                                    {{$common.getLocalTime(scope.row.createTime)}}
                                </div>
                                <div v-else>
                                    {{scope.row[item.prop]}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    name: 'selectTableKey',
    data() {
        return {
            selectTableId: "", //  table选中行id
            ss: "",
        };
    },
    props: {
        //  主组件菜单提示label
        label: {
            type: String,
            default: () => "选择装车单:",
        },
        // 模糊检索提示placeholder
        seachholder: {
            type: String,
            default: () => "输入出仓单号，按Enter快速检索",
        },
        // 下拉框提示placeholder
        placeholder: {
            type: String,
            default: () => "点击选择装车单请求数据",
        },
        // 下拉表格绑定的data数据
        memberList: {
            type: [Object, Array],
        },
        // 表格中的header头
        Columns: {
            type: [Object, Array],
        },
        // 选中时的值
        formInline: {
            type: [Number, String],
        },
        // 是否显示切换 下拉表格
        showTree: {
            type: Boolean,
        },
        // 选择下拉内容后的方法
        handleRegionNodeClick: {
            type: Function,
        },
    },
    watch: {
        formInline: function (newValue, oldValue) { },
    },
    mounted() { },
    methods: {
        // 表格css
        getCellStyle() {
            return "text-align:center; ";
        },
        getHeaderCellStyle() {
            return "background: rgba(9, 37, 56,0.1);text-align:center; background: linear-gradient(to bottom,#ffffff 0,#eeeeee 100%);padding: 4px 5px;";
        },
        // 点击input 阻止冒泡 控制table显示隐藏
        deptogglePanel(event) {
            event || (event = window.event);
            event.stopPropagation
                ? event.stopPropagation()
                : (event.cancelBubble = true);
            this.showTree ? this.tableHide() : this.tableShow();
        },
        tableShow() {
            this.$emit("showChange", true);
            //   this.showTree = true;
            document.addEventListener("click", this.tableHideList, false);
        },
        tableHide() {
            this.$emit("noShowChange", false);
            //   this.showTree = false;
            document.addEventListener("click", this.tableHideList, false);
        },
        tableHideList(e) {
            if (this.$refs.tableList && !this.$refs.tableList.contains(e.target)) {
                this.tableHide();
            }
        },
        // 检索输入框 值变化后  要检索的条件
        searchInputChange(e) {
            this.$emit("inputChange", e);
        },
        // 点击table节点
        // handleRegionNodeClick(data) {
        //   this.$emit("selectTableClick", data);
        //   //   console.log(data);
        //   this.selectTableId = data.caid;
        //   this.formInline.member = data.caname; // 用户名字
        //   this.showTree = false;
        // },
    },
};
</script>
<style scoped>
.treeDiv {
    position: absolute;
    background: #fff;
    top: 40px;
    left: -1px;
    z-index: 1000;
    width: 280%;
    overflow: auto;
    max-height: 400px;
    border: solid 1px #eee;
}
.el-table {
    border: 1px solid #ccc;
    border-radius: 6px;
}
.el-table ::v-deep td {
    padding: 4px 0;
}
</style>
